import {IFileObject, IFormField} from 'models/Common'
import {IFields} from 'models/GenericForm'

export const createPayload = async (
 fields: IFields[] | undefined,
 formData: IFormField,
 uploadedFileData: IFileObject
) => {
 const payload: IFormField = {}
 if (fields) {
  for (const field of fields) {
   let value
   const labelKey = field.label_key
   if (
    ['IMAGE_FIELD', 'FILE_FIELD'].includes(field.field_type)
   ) {
    const fileArr: string[] = []
    if (field?.is_multiple) {
     Array.from(
      {
       length: formData?.[labelKey]?.length,
      },
      (_, index) => {
       if (
        uploadedFileData?.[`${labelKey}.${index}`]?.filePath
       ) {
        fileArr.push(
         uploadedFileData?.[`${labelKey}.${index}`]
          ?.filePath
        )
       }
      }
     )
     value = fileArr
    } else {
     value = uploadedFileData?.[labelKey]?.filePath
    }
   } else {
    value = formData?.[labelKey] ?? ''
   }
   if (field?.parse_type) {
    switch (field.parse_type) {
     case 'multi_text':
      value = [value]
      break
     case 'text':
      value = value?.toString()
      break
     case 'decimal':
      value = Number(value)
      break
     case 'bool':
      value = formData?.[labelKey] ? true : false
      break
     default:
      value = value?.toString()
      break
    }
   }

   payload[labelKey] = value
  }
 }

 return payload
}
